import { Button, CardActions, CardContent, Modal, Typography } from '@mui/material';
import { ConfirmCard } from './Styles';
import { useRefresh } from './RefreshContext';

interface LineStopConfirmModalProps {
    open: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export default function LineStopConfirmModal({ open, onConfirm, onCancel }: LineStopConfirmModalProps) {
    const handleCancel = () => {
        onCancel();
    };

    const handleConfirm = () => {
        onConfirm();
    };
    const { isRefreshing } = useRefresh();
    return (
        <Modal open={open} onClose={handleCancel}>
            <ConfirmCard>
                <CardContent sx={{ p: 2 }}>
                    <Typography variant='h6' mb={2}>
                        Szeretné megváltoztatni a többi megálló indulási idejét is?
                    </Typography>
                </CardContent>
                <CardActions sx={{ justifyContent: 'space-between' }}>
                    <Button disabled={isRefreshing} variant='contained' onClick={handleConfirm} sx={{ mr: 1 }}>
                        {isRefreshing ? 'Loading...' : 'Igen'}
                    </Button>
                    <Button variant='outlined' onClick={handleCancel}>
                        Nem
                    </Button>
                </CardActions>
            </ConfirmCard>
        </Modal>
    );
}
